<div id="pnmanage" class="sidebar-manage" style="display: block">
  <div class="pnContent">
    <div class="pnclose">
      <a (click)="closePannel()"><i class="fa fa-chevron-circle-left fa1x"></i></a>
    </div>
    <div class="commonFormsCss">
      <h3>Find Order</h3>
      <ng-template [ngIf]="findOrderForm !== '1'">
        <form [formGroup]="findOrderForm" (submit)="searchOrder()">
          <div class="sidebar-search">
            <div class="input-group custom-search-form">
              <input
                type="text"
                formControlName="pnrNumber"
                [class.is-invalid]="inp_group('pnrNumber').hasError('required') && inp_group('pnrNumber').touched"
                placeholder="Search PNR..."
                class="search"
                #pnr
              />
              <button type="submit" [disabled]="isSearchRequestGenerated" class="serachBtn">
                <i class="fa fa-search"></i>
              </button>
              <br />
              <br />
              <div class="mt-3" *ngIf="isPnrNumberInBookingReferences()">
                <h3>Split Orders</h3>

                <select id="pnrs" formControlName="selectedPNRNumber" class="form-control" (change)="setActivePNR($event)">
                  <option *ngFor="let pnrNumber of bookingReferences.pnrNumbers" [value]="pnrNumber">{{ pnrNumber }}</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </ng-template>
    </div>
    <div id="pnManageMnu" *ngIf="isYourBookingMapped">
      <div class="pnContent">
        <div class="mt-10 mb-20"></div>
        <br />

        <div class="text-color bookingOptions">
          <ng-template [ngIf]="!isSMEUser && isYourBookingMapped && yourBookingScreen.booking.isDisrupted && isYourBookingStatus === 'CONFIRMED'">
            <ng-template
              [ngIf]="
                yourBookingScreen.booking.disruptedDetails.displayCallAirline ||
                yourBookingScreen.booking.disruptedDetails.displayAccept ||
                yourBookingScreen.booking.disruptedDetails.displayCancel ||
                yourBookingScreen.booking.disruptedDetails.displayReshop
              "
            >
              <h3>Manage Booking</h3>
            </ng-template>

            <div *ngIf="yourBookingScreen.booking.disruptedDetails.displayCallAirline && !isSMEUser"><i class="fa fa-phone-square-alt"></i>Call Airline</div>
            <a href="#" *ngIf="yourBookingScreen.booking.disruptedDetails.displayAccept && !isSMEUser" (click)="acceptChangedDisruptedFilghts()"
              ><i class="fa fa-check-circle"></i> Accept Change (Disrupted)</a
            >

            <a href="#" *ngIf="yourBookingScreen.booking.disruptedDetails.displayCancel && !isSMEUser" (click)="cancelBookingRefundOption()"
              ><i class="fa fa-times-circle"></i> Cancel Booking (Get Refund Options)</a
            >

            <!-- <a href="#" *ngIf="yourBookingScreen.booking.disruptedDetails.displayCancel" (click)="cancelBookingIssueVoucher()"><i class="fa fa-times-circle"></i> Cancel Booking (Issue Voucher)</a> -->

            <a *ngIf="yourBookingScreen.booking.disruptedDetails.displayReshop" (click)="changeDate()"><i class="fa fa-calendar-alt"></i> Change Date/Time Flight</a>
          </ng-template>
          <ng-template [ngIf]="isYourBookingMapped && !yourBookingScreen.booking.isDisrupted">
            <div class="bookingOptions" *ngIf="isYourBookingStatus === 'HOLD'">
              <h3>Manage Booking</h3>
              <a *ngIf="!isSMEUser" href="#" (click)="issueTicket()"><i class="fa fa-ticket-alt"></i> Issue Tickets</a>
              <a href="#" (click)="reQuoteTicket()"><i class="fa fa-ticket-alt"></i> ReQuote Held Booking</a>

              <a *ngIf="!isSMEUser" href="#" data-bs-toggle="modal" data-bs-target="#CancelHeldBookingPopup"><i class="fa fa-times-circle"></i> Cancel Held Booking</a>
              <a *ngIf="!isSMEUser" (click)="addAncilliaries()"><i class="baIcn ba-carryOn-bag ba-3x ba-mg-7-mid"></i> Add Ancilliaries</a>
              <a (click)="changeDate()"><i class="fa fa-calendar-alt"></i> Change Date/Time Flight</a>
              <a *ngIf="!isSMEUser" data-bs-toggle="modal" data-bs-target="#disruptBookingPopup"><i class="fa fa-exclamation-triangle"></i> OCN Cancel & ReAccommodate</a>

            </div>
            <div *ngIf="isYourBookingStatus === 'CONFIRMED'">
              <h3>Manage Booking</h3>

              <a *ngIf="!isSMEUser" href="#" (click)="cancelBookingRefundOption()"><i class="fa fa-times-circle"></i> Cancel Booking( Get Refund Options)</a>
              <a (click)="changeDate()"><i class="fa fa-calendar-alt"></i> Change Date/Time Flight</a>

              <a *ngIf="!isSMEUser" (click)="addAncilliaries()"><i class="baIcn ba-carryOn-bag ba-3x ba-mg-7-mid"></i> Add Ancilliaries</a>
              <a *ngIf="!isSMEUser" (click)="ChangePassengerName()"><i class="fa fa-edit"></i> Passenger Name Change</a>
              <a *ngIf="!isSMEUser" (click)="splitBooking()"><i class="fa fa-cut"></i> Split Booking</a>
              <a *ngIf="!isSMEUser" data-bs-toggle="modal" data-bs-target="#disruptBookingPopup"><i class="fa fa-exclamation-triangle"></i> OCN Cancel & ReAccomodate</a>


              <!--To be implemented as part of future requirement -->
              <!-- <a href="#" (click)="cancelBookingIssueVoucher()"><i class="fa fa-times-circle"></i> Cancel Booking( Issue Voucher)</a> -->
              <!-- <br /><br /> -->
            </div>
          </ng-template>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</div>
